import React, { useEffect, useState } from "react";
import { Hash } from "lucide-react";
import { api } from "@/lib/api";

export function InvoiceNumbering({ refresh }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/invoice-numbering").then((r) => setD(r.data)).catch(() => setD(null));
  }, [refresh]);
  if (!d) return null;
  return (
    <div className="border border-gold-700/40 bg-gold-950/20 p-4 mb-5 flex flex-wrap gap-6 items-center" data-testid="invoice-numbering">
      <Hash className="w-5 h-5 text-gold-400" />
      <div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">Posledné vydané číslo</div>
        <div className="font-mono text-lg text-white" data-testid="invoice-numbering-last">{d.last || "— zatiaľ žiadne —"}</div>
      </div>
      <div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">Nasledujúce voľné číslo</div>
        <div className="font-mono text-lg text-gold-400" data-testid="invoice-numbering-next">{d.next}</div>
      </div>
      <div className="text-xs text-zinc-500" data-testid="invoice-numbering-count">Vydaných v {d.year}: {d.count}</div>
    </div>
  );
}
